import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import styled, { keyframes } from 'styled-components';
import { bounceIn } from 'react-animations';

import ContentDetail from './ContentDetail';
import { db } from '../firebase/index';
import './Content.css';

const bounceInAnimation = keyframes`${bounceIn}`;

const BounceInDiv = styled.div`
  animation: 1s ${bounceInAnimation};
`;

class ContentComplete extends Component {
  state = {
    boothId: this.props.location.state.boothId['boothId'],
    resultId: this.props.location.state.resultId[0],
    name: this.props.location.state.resultId[0]['name'],
    url: this.props.location.state.resultId[0]['url']
  }
  componentDidMount() {
    this.handleLikeUpdate();
  }
  handleLikeUpdate = () => {
    const { name } = this.state;
    db.collection('images').get().then((querySnapshot) => {   //images를 나중에 boothId로 수정해야됨
      querySnapshot.forEach((doc) => {
        if (doc.data().name === name) {
          const id = doc.id;
          const oldLike = doc.data().like;
          db.collection('images').doc(id).update({
            like: oldLike+1
          })
        }
      });
    })
    .then(() => console.log('Update successfully'))
    .catch((error) => console.log(error));
  }

  render(){
    library.add(faTimes);
    
    const { boothId, resultId } = this.state;
    
    return(
      <div className="content-complete content">
        <a className="close" href="zepeto://WEBVIEW/CLOSE"><FontAwesomeIcon icon="times" /></a>
        <div className="content-card content-card-complete">
          <div className="content-complete-title">
            <span role="img" aria-label="celeb">🎉</span>
            <b> Your Ideal type </b>
            <span role="img" aria-label="celeb">🎉</span>
          </div>
          <BounceInDiv>
            <ContentDetail info={resultId} elems={resultId} onClick={this.handlePick} from="complete" />
          </BounceInDiv>
          {/* <Link to=''>Upload My ZEPETO</Link>
          <Link to=''>Recommend ZEPETO</Link> */}
          <div className="a-container">
            <Link to={{
                pathname: `/${boothId}/ranking`,
                state: { boothId: boothId }
              }}
              className="a-btn">Ranking</Link>
            <Link to= {`/${boothId}`} className="a-btn">REPLAY</Link>
            
          </div>
        </div>
      </div>
    );
  }
}
export default ContentComplete;
